// src/common/components/cartModal/components/processingStage/ProcessingStage.tsx

import React from "react";
import { useTheme } from "../../../../hooks/useTheme";
import styles from "./ProcessingStage.module.scss";
import { useProcessingStage } from "../../hooks/useProcessingStage";
import Loader from "../../../loader/Loader";

interface ProcessingStageProps {
  orderId: number | null;
  onPaid?: () => void;
  onTimeout?: () => void;
  onGoToOrders?: () => void;
  onContinueShopping?: () => void;
  message?: string;
  timeoutMessage?: string;
  timeout?: number;
  intervalTime?: number;
}

export const ProcessingStage = ({
  orderId,
  onPaid,
  onTimeout,
  onGoToOrders,
  onContinueShopping,
  message = "Оформляем заказ и проверяем оплату...",
  timeoutMessage = "Не дождались подтверждения. Проверьте статус заказа в истории.",
  timeout = 20000,
  intervalTime = 3000,
}: ProcessingStageProps) => {
  const { theme } = useTheme();
  const { isTimedOut } = useProcessingStage({
    orderId,
    timeout,
    intervalTime,
    onPaid,
    onTimeout,
  });

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <div className={styles.content}>
        {!isTimedOut ? (
          <>
            <div className={styles.loaderWrapper}>
              <Loader />
            </div>
            <p className={styles.message} style={{ color: theme.text }}>
              {message}
            </p>
          </>
        ) : (
          <>
            <div className={styles.iconWrapper}>
              <span className={styles.icon}>⏰</span>
            </div>
            <p className={styles.message} style={{ color: theme.text }}>
              {timeoutMessage}
            </p>
            <div className={styles.buttons}>
              {onGoToOrders && (
                <button
                  className={styles.button}
                  style={{ backgroundColor: theme.primary, color: "#fff" }}
                  onClick={onGoToOrders}
                >
                  Мои заказы
                </button>
              )}
              {onContinueShopping && (
                <button
                  className={`${styles.button} ${styles.secondary}`}
                  style={{
                    backgroundColor: theme.card,
                    color: theme.text,
                    borderColor: theme.border,
                  }}
                  onClick={onContinueShopping}
                >
                  Продолжить покупки
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
